<section class="dash animate-fade-in" aria-labelledby="dash-title">
  <header class="dash-header">
    <h1 id="dash-title" class="dash-header__title">Dashboard</h1>
    <p class="dash-header__lead">What needs attention today.</p>
  </header>

  @if (loading()) {
    <div class="dash-cards" data-count="4" aria-busy="true" aria-label="Loading dashboard">
      @for (slot of [1, 2, 3, 4]; track slot) {
        <div class="dash-card dash-card--skeleton"></div>
      }
    </div>
  } @else if (error()) {
    <div class="dash-error" role="alert">
      <p>{{ error() }}</p>
      <button type="button" class="dash-retry" (click)="load()">Try again</button>
    </div>
  } @else if (data(); as dash) {
    <div class="dash-cards" [attr.data-count]="cardCount()">
      <a class="dash-card" routerLink="/content-manager">
        <span class="dash-card__label">Pending approval</span>
        <span class="dash-card__value">{{ dash.pending_approval }}</span>
      </a>
      <a class="dash-card" routerLink="/content-manager">
        <span class="dash-card__label">Created today</span>
        <span class="dash-card__value">{{ dash.created_today }}</span>
      </a>
      @if (showRuns()) {
        <a class="dash-card" routerLink="/agents">
          <span class="dash-card__label">Failed runs today</span>
          <span class="dash-card__value">{{ dash.failed_runs_today ?? 0 }}</span>
        </a>
      }
      @if (showSync()) {
        <article class="dash-card">
          <span class="dash-card__label">Last sync</span>
          <span class="dash-card__value dash-card__value--text">{{ syncHeadline() }}</span>
          <span class="dash-card__meta">
            @if (dash.last_sync; as sync) {
              {{ sync.mode }} · {{ sync.created_at | date:'d MMM, HH:mm' }}
            } @else {
              No sync yet
            }
          </span>
        </article>
      }
    </div>

    @if (showRuns()) {
    <div class="dash-lists dash-lists--split">
      <section class="dash-panel" aria-labelledby="dash-agents-title">
        <div class="dash-panel__header">
          <h2 id="dash-agents-title" class="dash-panel__title">Agents</h2>
          <a class="dash-panel__link" routerLink="/agents">Open</a>
        </div>
        @if (!dash.agents.length) {
          <p class="dash-empty">No agents yet.</p>
        } @else {
          <ul class="dash-rows">
            @for (agent of dash.agents; track agent.agent_id) {
              <li>
                <a class="dash-row" routerLink="/agents">
                  <span class="dash-row__title">{{ agent.app_name || agent.app_id }}</span>
                  <span class="dash-row__meta">
                    @if (agent.is_running) {
                      Running now
                    } @else if (agent.is_active) {
                      Every {{ agent.trigger_interval }}
                    } @else {
                      Paused
                    }
                  </span>
                  <time class="dash-row__time" [attr.datetime]="agent.next_trigger_at || agent.last_triggered_at">
                    @if (agent.is_running) {
                      In progress
                    } @else if (agent.next_trigger_at) {
                      Next {{ agent.next_trigger_at | date:'d MMM, HH:mm' }}
                    } @else if (agent.last_triggered_at) {
                      Last {{ agent.last_triggered_at | date:'d MMM, HH:mm' }}
                    } @else {
                      Not scheduled
                    }
                  </time>
                </a>
              </li>
            }
          </ul>
        }
      </section>

        <section class="dash-panel" aria-labelledby="dash-failures-title">
          <div class="dash-panel__header">
            <h2 id="dash-failures-title" class="dash-panel__title">Failed runs today</h2>
            <a class="dash-panel__link" routerLink="/agents">Agents</a>
          </div>
          @if (!dash.recent_failures.length) {
            <p class="dash-empty">No failed runs today.</p>
          } @else {
            <ul class="dash-rows">
              @for (run of dash.recent_failures; track run.run_id) {
                <li>
                  <a class="dash-row" routerLink="/agents">
                    <span class="dash-row__title">{{ run.app_id }}</span>
                    <span class="dash-row__meta">{{ run.error || 'Run failed' }}</span>
                    <time class="dash-row__time" [attr.datetime]="run.created_at">{{ run.created_at | date:'d MMM, HH:mm' }}</time>
                  </a>
                </li>
              }
            </ul>
          }
        </section>
    </div>
    }
  }
</section>
